import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const EvaluationItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 14px 20px;
`;
const EvaluationName = styled.span`
  font-size: 12px;
  color: ${props => props.color};
`;
const EvaluationMaxNote = styled.span`
  font-size: 10px;
  color: ${props => props.color};
`;
const EvaluationNote = styled.span`
  font-size: 18px;
  color: ${props => props.color};
  font-weight: bold;
`;
const NameContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const EvaluationListItem = props => {
  const { evaluation } = props;
  const { t } = useTranslation();
  return (
    <div>
      <EvaluationItem>
        <NameContainer>
          <EvaluationName>{evaluation.description}</EvaluationName>
        </NameContainer>
        {evaluation.maxNote && (
          <EvaluationMaxNote>
            {t("student.stats.maxGrade", { max: evaluation.maxNote })}
          </EvaluationMaxNote>
        )}
        <EvaluationNote color={evaluation.color}>
          {evaluation.value || "-"}
        </EvaluationNote>
      </EvaluationItem>
    </div>
  );
};

EvaluationListItem.propTypes = {
  evaluation: PropTypes.objectOf().isRequired
};

export default EvaluationListItem;
